import { defineMessages } from 'react-intl';

export const libraryDocumentPickerListMessages = defineMessages({
  workflowContextSearchPlaceholder: {
    defaultMessage: 'Search skill files',
    id: 'qQIt+MzkK8',
    description: 'Workflow context document picker search placeholder',
  },
  workflowContextSearchAria: {
    defaultMessage: 'Search routine context files',
    id: '9HtmJDubg/',
    description: 'Workflow context document picker search accessible label',
  },
  workflowContextLoading: {
    defaultMessage: 'Loading files',
    id: 'xSBtzXkrSm',
    description: 'Workflow context document picker loading state',
  },
  workflowContextEmptySearch: {
    defaultMessage: 'No files match your search.',
    id: 'p8E7nZnHXT',
    description: 'Workflow context document picker empty search results',
  },
  workflowContextEmpty: {
    defaultMessage: 'No skill files yet — upload one below.',
    id: 'GXFo9CIVq7',
    description: 'Workflow context document picker empty state',
  },
  artifactSearchPlaceholder: {
    defaultMessage: 'Search Heidi outputs',
    id: 'r7ubXF7boa',
    description: 'Work output document picker search placeholder',
  },
  artifactSearchAria: {
    defaultMessage: 'Search Heidi output documents',
    id: '+ekUX+0lvR',
    description: 'Work output document picker search accessible label',
  },
  artifactLoading: {
    defaultMessage: 'Loading Heidi outputs',
    id: 'iprY6P41PC',
    description: 'Work output document picker loading state',
  },
  artifactEmptySearch: {
    defaultMessage: 'No Heidi outputs match your search.',
    id: 'UPQ6jf9Art',
    description: 'Work output document picker empty search results',
  },
  artifactEmpty: {
    defaultMessage: 'No Heidi outputs yet. Save one from a chat export.',
    id: 'L5SsYlrinH',
    description: 'Work output document picker empty state',
  },
  refreshing: {
    defaultMessage: 'Refreshing',
    id: 'kP2c8CROnm',
    description: 'Document picker refreshing state suffix',
  },
});
